import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix icono default de Leaflet (webpack lo rompe)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const ALTAN_WMS = 'https://geomap.altanredes.com/geoserver/web_altanredes_geoaltan/ows?SERVICE=WMS?&authkey=a42849d0';

export default function MapaCobertura() {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const [direccion, setDireccion] = useState('');
  const [buscando, setBuscando] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (mapInstance.current) return;

    // Crear mapa centrado en México
    const map = L.map(mapRef.current).setView([19.2878600, -99.6532400], 5);
    mapInstance.current = map;

    // Tile de OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '<a href="https://www.altanredes.com">ALTAN</a> Altan-Maps',
      maxZoom: 18
    }).addTo(map);

    L.control.scale({ position: 'bottomright' }).addTo(map);

    // Marker inicial
    markerRef.current = L.marker([19.2878600, -99.6532400], { draggable: true }).addTo(map);

    // Capa WMS de cobertura de Altán
    L.tileLayer.wms(ALTAN_WMS, {
      layers: 'Cobertura_Actual',
      format: 'image/png',
      transparent: true,
      tiled: true,
    }).addTo(map);

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, []);

  const buscarDireccion = async (e) => {
    if (e) e.preventDefault();
    if (!direccion.trim()) return;

    setBuscando(true);
    setError('');

    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(direccion + ', México')}&limit=1`;
      const res = await fetch(url, {
        headers: { 'Accept-Language': 'es' }
      });
      const data = await res.json();

      if (data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lng = parseFloat(data[0].lon);
        mapInstance.current.setView([lat, lng], 16);
        if (markerRef.current) {
          markerRef.current.setLatLng([lat, lng]);
        } else {
          markerRef.current = L.marker([lat, lng], { draggable: true }).addTo(mapInstance.current);
        }
      } else {
        setError('Dirección no encontrada. Intenta con más detalle (ej: Colonia, Ciudad)');
      }
    } catch (err) {
      setError('Error al buscar dirección');
    } finally {
      setBuscando(false);
    }
  };

  const miUbicacion = () => {
    if (!navigator.geolocation) {
      setError('Tu navegador no soporta geolocalización');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        mapInstance.current.setView([latitude, longitude], 18);
        if (markerRef.current) {
          markerRef.current.setLatLng([latitude, longitude]);
        } else {
          markerRef.current = L.marker([latitude, longitude], { draggable: false }).addTo(mapInstance.current);
        }
      },
      () => setError('No pudimos obtener tu ubicación')
    );
  };

  return (
    <div>
      <form onSubmit={buscarDireccion} style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input
          type="text"
          placeholder="Ej: Av. Reforma, CDMX"
          value={direccion}
          onChange={(e) => setDireccion(e.target.value)}
          style={{
            flex: 1,
            padding: '12px 14px',
            borderRadius: 10,
            border: '1px solid #d4e8d6',
            fontSize: 14,
          }}
        />
        <button type="submit" disabled={buscando} style={{
          padding: '12px 18px',
          background: '#1a3a2a',
          color: '#fff',
          border: 'none',
          borderRadius: 10,
          fontWeight: 600,
          cursor: 'pointer',
        }}>
          {buscando ? '...' : '🔍'}
        </button>
        <button type="button" onClick={miUbicacion} style={{
          padding: '12px 18px',
          background: '#2d6a4f',
          color: '#fff',
          border: 'none',
          borderRadius: 10,
          fontWeight: 600,
          cursor: 'pointer',
        }}>
          📍
        </button>
      </form>

      {error && (
        <div style={{ padding: 10, background: '#fef2f2', color: '#ef4444', borderRadius: 8, marginBottom: 12, fontSize: 13 }}>
          {error}
        </div>
      )}

      <div
        ref={mapRef}
        style={{ width: '100%', height: 500, borderRadius: 14, overflow: 'hidden' }}
      />
    </div>
  );
}
